/**
 * Returns if a string is dollars or not. And to exactly 2 decimal places.
 * @param {string} str string value to be validated
 * @returns {boolean}
 */
export const isDollars = str => {
  var decimalIndex = str.lastIndexOf('.')
  if (decimalIndex == -1) return false
  var dollars = str.slice(0, decimalIndex)
  var cents = str.slice(decimalIndex + 1)
  if (/^[0-9]+$/.test(dollars) === false) return false
  if (/^[0-9]+$/.test(cents) === false) return false
  if (cents.length !== 2) return false
  return true
}
/**
 * Returns if a string is dollars or not. And to exactly 2 decimal places. Can be negative
 * @param {string} str string value to be validated
 * @returns {boolean}
 */
export const isDollarsAdjustment = str =>
  str.startsWith('-') ? isDollars(str.substring(1, str.length)) : isDollars(str)

/**
 * Check a string is a number
 * @param {string} str string value to be validated
 * @returns {boolean}
 */
export const isNumber = str => isNaN(Number(str)) === false
